import { useEffect, useState } from 'react';
import arrowDown from "@/public/svg/arrow-down.svg";
import arrowUp from "@/public/svg/arrow-up.svg";

const ScrollArrows = () => {
    const [isTop, setIsTop] = useState(true);
    const [isBottom, setIsBottom] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            setIsTop(scrollTop < 100);
            setIsBottom(scrollTop + windowHeight >= documentHeight - 100);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const scrollToBottom = () => {
        window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
    };

    return (
        <div className="fixed right-4 bottom-4 z-50">
            {!isTop && (
                <button
                    onClick={scrollToTop}
                    className="bg-lineGreen text-white rounded-full p-2 shadow hover:bg-primaryDark transition"
                    aria-label="Nach oben scrollen"
                >
                    <img src={arrowUp} alt="Pfeil nach oben" loading="lazy" className="w-6 h-6" />
                </button>
            )}
            {!isBottom && (
                <button
                    onClick={scrollToBottom}
                    className="bg-lineGreen text-white rounded-full p-2 shadow hover:bg-primaryDark transition"
                    aria-label="Nach unten scrollen"
                >
                    <img src={arrowDown} alt="Pfeil nach unten" loading="lazy" className="w-6 h-6" />
                </button>
            )}
        </div>
    );
};

export default ScrollArrows;        
